module.exports = __webpack_public_path__ + "img/bum(1).a4d73501.png";